import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

// https://www.wix.com/website-template/view/html/1715

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
